import { GLOBAL_PROMPT_DEFAULTS } from '../../ai/prompt-globals'
import type { AppConfigData } from './useAppConfig.types'

export const APP_CONFIG_DEFAULTS: AppConfigData = {
  appName: 'Jenna',
  appNameSecondary: 'AI',
  appTagline: 'Masuk ke Dashboard Desa',
  appDescription: 'Asisten Digital Desa',

  heroBadge: 'Platform Pelayanan Desa Berbasis AI',
  heroTitle: 'Layanan desa',
  heroHighlight: '24/7',
  heroSubtitle: 'langsung dari WhatsApp',

  footerText: 'Desa Platform — oleh wibudev',
  footerUrl: 'https://wibudev.com',

  primaryColor: 'blue',
  gradientFrom: 'blue',
  gradientTo: 'violet',

  features: [
    {
      icon: '💬',
      title: 'Chat AI 24/7',
      desc: 'Warga tanya jawab via WhatsApp & Telegram kapan saja, dijawab oleh AI yang memahami konteks desa.',
    },
    {
      icon: '📄',
      title: 'Surat Otomatis',
      desc: 'Pengajuan surat domisili, SKCK, dan lainnya cukup lewat percakapan. Tanpa antri, tanpa form rumit.',
    },
    {
      icon: '📢',
      title: 'Laporan Warga',
      desc: 'Laporkan masalah infrastruktur atau layanan desa. Petugas langsung dapat notifikasi real-time.',
    },
    {
      icon: '🏘️',
      title: 'Multi-Tenant',
      desc: 'Satu platform untuk banyak desa. Data terisolasi, setiap desa punya konfigurasi dan AI sendiri.',
    },
  ],

  kepalaDesaPermissions: [
    // Pelayanan
    'surat',
    'laporan',
    'bansos',
    'booking',
    'musrenbang',
    'life-events',
    // Data
    'kependudukan',
    'pertanahan',
    'kesehatan',
    'pendidikan',
    'pemilihan',
    // Operasional
    'kepegawaian',
    'keuangan',
    'pembangunan',
    'administrasi',
    'ekonomi',
    'ketertiban',
    'kelembagaan',
    // AI & Komunikasi
    'percakapan',
    'riwayat',
    'kepribadian-ai',
    'test-ai',
    'memory',
    'tools',
    'agen',
    // Konfigurasi
    'channel',
    'template-surat',
    'dokumen',
    'informasi',
    'pengaturan',
    // Manajemen & Pelaporan
    'staff',
    'statistik',
  ],

  globalPromptPrefix: GLOBAL_PROMPT_DEFAULTS.globalPromptPrefix,
  globalBlockedTopics: [...GLOBAL_PROMPT_DEFAULTS.globalBlockedTopics],
  globalPromptSuffix: GLOBAL_PROMPT_DEFAULTS.globalPromptSuffix,

  allowAdminRegistration: false,

  aiGlobalEnabled: true,
  aiGlobalDisabledMessage: '',

  bufferDelayWa: 4000,
  bufferDelayTg: 3000,
  bufferDelayWeb: 2000,
  bufferMaxWait: 15000,
  bufferMaxMessages: 10,

  mediaMaxPhotos: 3,
  mediaMaxPhotoMb: 5,
  mediaMaxVideoMb: 10,
  mediaPhotoMaxWidth: 1280,
  mediaPhotoQuality: 80,
  mediaPresignedExpirySec: 3600,

  cleanupCompletedDays: 30,
  cleanupExpiredDays: 7,
  cleanupRejectedDays: 7,
}

/** Merge partial config dari DB dengan defaults */
export function mergeConfig(partial: Partial<AppConfigData>): AppConfigData {
  return {
    ...APP_CONFIG_DEFAULTS,
    ...partial,
    features: partial.features && partial.features.length > 0 ? partial.features : APP_CONFIG_DEFAULTS.features,
    kepalaDesaPermissions:
      partial.kepalaDesaPermissions && partial.kepalaDesaPermissions.length > 0
        ? partial.kepalaDesaPermissions
        : APP_CONFIG_DEFAULTS.kepalaDesaPermissions,
    globalBlockedTopics:
      partial.globalBlockedTopics && partial.globalBlockedTopics.length > 0
        ? partial.globalBlockedTopics
        : APP_CONFIG_DEFAULTS.globalBlockedTopics,
  }
}
